import {
  Companion_getInstance124t3fbljdbyi as Companion_getInstance,
  Clientuccelyr89ch8 as Client,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Addresscpovxna1tjmg as Address } from './supportModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client__id_getInstance());
}
function get_userFirstName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_userFirstName_getInstance());
}
function get_userLastName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_userLastName_getInstance());
}
function get_email(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_email_getInstance());
}
function get_phoneNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_phoneNumber_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_address_getInstance());
}
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_contractor_getInstance());
}
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.prop(Client_name_getInstance());
}
function prepareClientFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Client__id_getInstance(), Client_contractor_getInstance(), Client_name_getInstance(), Client_userFirstName_getInstance(), Client_userLastName_getInstance(), Client_email_getInstance(), Client_phoneNumber_getInstance(), Client_address_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Client__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Client__id$_get_name_$ref_ym6rqr() {
  return (p0) => p0.k20();
}
function Client__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client__id$_get_serializer_$ref_ubr4ka() {
  return (p0) => p0.j2j();
}
function Client__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Client__id$_get_annotations_$ref_wtlaaq() {
  return (p0) => p0.bz();
}
var Client__idClass;
function Client__id() {
  if (Client__idClass === VOID) {
    class $ {
      constructor() {
        Client__id_instance = this;
        var tmp = this;
        tmp.x5b_1 = lazy(Client__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y5b_1 = lazy(Client__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z5b_1 = lazy(Client__id$annotations$delegate$lambda);
        this.a5c_1 = Companion_getInstance_0().m2p();
        this.b5c_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.x5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client__id$_get_name_$ref_ym6rqr(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.d5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      l5c(receiver, value) {
        return receiver.m5c(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.l5c(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client__id$_get_serializer_$ref_ubr4ka(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client__id$_get_annotations_$ref_wtlaaq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client__id', VOID, VOID, [SerializableProperty()]);
    Client__idClass = $;
  }
  return Client__idClass;
}
var Client__id_instance;
function Client__id_getInstance() {
  if (Client__id_instance === VOID)
    new (Client__id())();
  return Client__id_instance;
}
function Client_userFirstName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Client_userFirstName$_get_name_$ref_mriabt() {
  return (p0) => p0.k20();
}
function Client_userFirstName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_userFirstName$_get_serializer_$ref_thve1c() {
  return (p0) => p0.j2j();
}
function Client_userFirstName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Client_userFirstName$_get_annotations_$ref_p44p1o() {
  return (p0) => p0.bz();
}
var Client_userFirstNameClass;
function Client_userFirstName() {
  if (Client_userFirstNameClass === VOID) {
    class $ {
      constructor() {
        Client_userFirstName_instance = this;
        var tmp = this;
        tmp.n5c_1 = lazy(Client_userFirstName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o5c_1 = lazy(Client_userFirstName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p5c_1 = lazy(Client_userFirstName$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_userFirstName$_get_name_$ref_mriabt(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.g5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      q5c(receiver, value) {
        return receiver.m5c(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.q5c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_userFirstName$_get_serializer_$ref_thve1c(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_userFirstName$_get_annotations_$ref_p44p1o(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_userFirstName', VOID, VOID, [SerializableProperty()]);
    Client_userFirstNameClass = $;
  }
  return Client_userFirstNameClass;
}
var Client_userFirstName_instance;
function Client_userFirstName_getInstance() {
  if (Client_userFirstName_instance === VOID)
    new (Client_userFirstName())();
  return Client_userFirstName_instance;
}
function Client_userLastName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Client_userLastName$_get_name_$ref_nh80fn() {
  return (p0) => p0.k20();
}
function Client_userLastName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_userLastName$_get_serializer_$ref_89smh8() {
  return (p0) => p0.j2j();
}
function Client_userLastName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Client_userLastName$_get_annotations_$ref_r8m4e0() {
  return (p0) => p0.bz();
}
var Client_userLastNameClass;
function Client_userLastName() {
  if (Client_userLastNameClass === VOID) {
    class $ {
      constructor() {
        Client_userLastName_instance = this;
        var tmp = this;
        tmp.r5c_1 = lazy(Client_userLastName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5c_1 = lazy(Client_userLastName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5c_1 = lazy(Client_userLastName$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_userLastName$_get_name_$ref_nh80fn(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.h5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      q5c(receiver, value) {
        return receiver.m5c(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.q5c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_userLastName$_get_serializer_$ref_89smh8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_userLastName$_get_annotations_$ref_r8m4e0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_userLastName', VOID, VOID, [SerializableProperty()]);
    Client_userLastNameClass = $;
  }
  return Client_userLastNameClass;
}
var Client_userLastName_instance;
function Client_userLastName_getInstance() {
  if (Client_userLastName_instance === VOID)
    new (Client_userLastName())();
  return Client_userLastName_instance;
}
function Client_email$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Client_email$_get_name_$ref_8p7uhh() {
  return (p0) => p0.k20();
}
function Client_email$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_email$_get_serializer_$ref_72mxdo() {
  return (p0) => p0.j2j();
}
function Client_email$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Client_email$_get_annotations_$ref_ma3ncw() {
  return (p0) => p0.bz();
}
var Client_emailClass;
function Client_email() {
  if (Client_emailClass === VOID) {
    class $ {
      constructor() {
        Client_email_instance = this;
        var tmp = this;
        tmp.u5c_1 = lazy(Client_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v5c_1 = lazy(Client_email$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w5c_1 = lazy(Client_email$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_email$_get_name_$ref_8p7uhh(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.i5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      q5c(receiver, value) {
        return receiver.m5c(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.q5c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_email$_get_serializer_$ref_72mxdo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_email$_get_annotations_$ref_ma3ncw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_email', VOID, VOID, [SerializableProperty()]);
    Client_emailClass = $;
  }
  return Client_emailClass;
}
var Client_email_instance;
function Client_email_getInstance() {
  if (Client_email_instance === VOID)
    new (Client_email())();
  return Client_email_instance;
}
function Client_phoneNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Client_phoneNumber$_get_name_$ref_bai66o() {
  return (p0) => p0.k20();
}
function Client_phoneNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_phoneNumber$_get_serializer_$ref_rv2lk9() {
  return (p0) => p0.j2j();
}
function Client_phoneNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Client_phoneNumber$_get_annotations_$ref_4pt5s5() {
  return (p0) => p0.bz();
}
var Client_phoneNumberClass;
function Client_phoneNumber() {
  if (Client_phoneNumberClass === VOID) {
    class $ {
      constructor() {
        Client_phoneNumber_instance = this;
        var tmp = this;
        tmp.x5c_1 = lazy(Client_phoneNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y5c_1 = lazy(Client_phoneNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z5c_1 = lazy(Client_phoneNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_phoneNumber$_get_name_$ref_bai66o(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.j5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      q5c(receiver, value) {
        return receiver.m5c(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.q5c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_phoneNumber$_get_serializer_$ref_rv2lk9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z5c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_phoneNumber$_get_annotations_$ref_4pt5s5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_phoneNumber', VOID, VOID, [SerializableProperty()]);
    Client_phoneNumberClass = $;
  }
  return Client_phoneNumberClass;
}
var Client_phoneNumber_instance;
function Client_phoneNumber_getInstance() {
  if (Client_phoneNumber_instance === VOID)
    new (Client_phoneNumber())();
  return Client_phoneNumber_instance;
}
function Client_address$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function Client_address$_get_name_$ref_z2eo31() {
  return (p0) => p0.k20();
}
function Client_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_address$_get_serializer_$ref_5iq4es() {
  return (p0) => p0.j2j();
}
function Client_address$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function Client_address$_get_annotations_$ref_pv5aoo() {
  return (p0) => p0.bz();
}
var Client_addressClass;
function Client_address() {
  if (Client_addressClass === VOID) {
    class $ {
      constructor() {
        Client_address_instance = this;
        var tmp = this;
        tmp.a5d_1 = lazy(Client_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b5d_1 = lazy(Client_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c5d_1 = lazy(Client_address$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_address$_get_name_$ref_z2eo31(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.k5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      d5d(receiver, value) {
        return receiver.m5c(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.d5d(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_address$_get_serializer_$ref_5iq4es(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_address$_get_annotations_$ref_pv5aoo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_address', VOID, VOID, [SerializableProperty()]);
    Client_addressClass = $;
  }
  return Client_addressClass;
}
var Client_address_instance;
function Client_address_getInstance() {
  if (Client_address_instance === VOID)
    new (Client_address())();
  return Client_address_instance;
}
function Client_contractor$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Client_contractor$_get_name_$ref_4k7hsa() {
  return (p0) => p0.k20();
}
function Client_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_contractor$_get_serializer_$ref_w3o3j1() {
  return (p0) => p0.j2j();
}
function Client_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Client_contractor$_get_annotations_$ref_gtvc8v() {
  return (p0) => p0.bz();
}
var Client_contractorClass;
function Client_contractor() {
  if (Client_contractorClass === VOID) {
    class $ {
      constructor() {
        Client_contractor_instance = this;
        var tmp = this;
        tmp.e5d_1 = lazy(Client_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f5d_1 = lazy(Client_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g5d_1 = lazy(Client_contractor$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_contractor$_get_name_$ref_4k7hsa(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.e5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      l5c(receiver, value) {
        return receiver.m5c(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.l5c(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_contractor$_get_serializer_$ref_w3o3j1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_contractor$_get_annotations_$ref_gtvc8v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_contractor', VOID, VOID, [SerializableProperty()]);
    Client_contractorClass = $;
  }
  return Client_contractorClass;
}
var Client_contractor_instance;
function Client_contractor_getInstance() {
  if (Client_contractor_instance === VOID)
    new (Client_contractor())();
  return Client_contractor_instance;
}
function Client_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Client_name$_get_name_$ref_dr979o() {
  return (p0) => p0.k20();
}
function Client_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Client_name$_get_serializer_$ref_28wshf() {
  return (p0) => p0.j2j();
}
function Client_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Client_name$_get_annotations_$ref_eqtjjd() {
  return (p0) => p0.bz();
}
var Client_nameClass;
function Client_name() {
  if (Client_nameClass === VOID) {
    class $ {
      constructor() {
        Client_name_instance = this;
        var tmp = this;
        tmp.h5d_1 = lazy(Client_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5d_1 = lazy(Client_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5d_1 = lazy(Client_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Client_name$_get_name_$ref_dr979o(), null);
        return tmp0.f2();
      }
      c5c(receiver) {
        return receiver.f5c_1;
      }
      m2j(receiver) {
        return this.c5c(receiver instanceof Client() ? receiver : THROW_CCE());
      }
      q5c(receiver, value) {
        return receiver.m5c(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Client() ? receiver : THROW_CCE();
        return this.q5c(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Client_name$_get_serializer_$ref_28wshf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Client_name$_get_annotations_$ref_eqtjjd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Client_name', VOID, VOID, [SerializableProperty()]);
    Client_nameClass = $;
  }
  return Client_nameClass;
}
var Client_name_instance;
function Client_name_getInstance() {
  if (Client_name_instance === VOID)
    new (Client_name())();
  return Client_name_instance;
}
//region block: exports
export {
  get__id as get__id2siepuxebop4k,
  get_address as get_address2if6gui37gjdo,
  get_contractor as get_contractor1cpbosmtltvri,
  get_email as get_email2n3fpv03ue5oj,
  get_name as get_name220tirn7t92ql,
  get_phoneNumber as get_phoneNumber3gk472wmm72lr,
  prepareClientFields as prepareClientFieldsyptl4y6dulio,
  get_userFirstName as get_userFirstName2cra61zxj7d12,
  get_userLastName as get_userLastName33o3zvsnv683s,
};
//endregion

//# sourceMappingURL=ClientFields.mjs.map
